__turbopack_context__.v({
  "className": "fjalla_one_f4b61e60-module__KZbT5q__className",
  "variable": "fjalla_one_f4b61e60-module__KZbT5q__variable",
});
